"use strict";

exports.__esModule = true;
exports.convertUrlMultilingual = convertUrlMultilingual;

var _consts = require("../consts/consts");

/**
 * Sanitizes the given URL by leaving only supported query params.
 *
 * @param {String} url original url
 * @param {String} lang value to add to url
 */
function convertUrlMultilingual(url, lang) {
  if (url && typeof url === 'string') {
    var queryIndex = url.indexOf(_consts.QUERY_SEPARATOR);

    if (queryIndex === -1) {
      return "" + url + _consts.QUERY_SEPARATOR + _consts.LANG_QUERY_PARAM + lang;
    } else {
      var query = url.split(_consts.QUERY_SEPARATOR)[1];

      if (query) {
        var langQueryIndex = url.indexOf(_consts.LANG_QUERY_PARAM);

        if (langQueryIndex !== -1) {
          var langRegex = new RegExp(_consts.LANG_QUERY_PARAM + "([a-zA-z])*");
          return url.replace(langRegex, "" + _consts.LANG_QUERY_PARAM + lang);
        }

        return "" + url + _consts.QUERY_PARAM_SEPARATOR + _consts.LANG_QUERY_PARAM + lang;
      } else {
        return "" + url + _consts.LANG_QUERY_PARAM + lang;
      }
    }
  }

  return '';
}